import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Transaction Type
export const fetchTransactionType = createAsyncThunk(
  "transactionType/fetchTransactionType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/transaction/panel/TransactionType");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Transaction Type
export const addTransactionType = createAsyncThunk(
  "transactionType/addTransactionType",
  async (newTransactionType, { rejectWithValue }) => {
    try {
      const response = await api.post("/transaction/panel/TransactionType", newTransactionType);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Transaction Type
export const updateTransactionType = createAsyncThunk(
  "transactionType/updateTransactionType",
  async (transactionTypeData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/transaction/panel/TransactionType", transactionTypeData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Transaction Type Slice
const transactionTypeSlice = createSlice({
  name: "transactionType",
  initialState: {
    transactionTypeList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Transaction Type
      .addCase(fetchTransactionType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTransactionType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.transactionTypeList = action.payload;
      })
      .addCase(fetchTransactionType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Transaction Type
      .addCase(addTransactionType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addTransactionType.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addTransactionType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Transaction Type
      .addCase(updateTransactionType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateTransactionType.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateTransactionType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = transactionTypeSlice.actions;

export default transactionTypeSlice.reducer;
